import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const StyledFlagWrapper = styled(Link)`
	align-self: center;
	display: flex;
	flex-wrap: wrap;
	font-family: ${({ theme }) => theme.fontFamily.primary};
	font-size: 14px;
	font-weight: ${({ theme }) => theme.fontWeight.bold};
	height: 70px;
	position: fixed;
	right: 0;
	top: calc(var(--inner-height) / 2 - 35px);
	width: 140px;
	z-index: 1000;
	a {
		text-decoration: none;
		color: inherit;
		underline: none;
		cursor: pointer;
	}
	div {
		padding: 4px 8px;
		align-items: center;
		display: flex;
		justify-content: center;
		&:nth-child(1) {
			background-color: #00e9d1;
			color: #030e3e;
			height: 50%;
			width: 100%;
		}
		&:nth-child(2) {
			background-color: #030e3e;
			color: white;
			height: 50%;
			width: 100%;
		}
		&:nth-child(3) {
			background-color: #e31f25;
			color: white;
			height: 50%;
			width: 100%;
		}
	}

	@media (max-width: 601px) {
		display: none;
	}
`;

const UkrainianCargoFlag = () => {
	return (
		<StyledFlagWrapper>
			<div>
				<a href="https://bip.port.szczecin.pl/przetargi-nieruchomosci/47">Przetarg</a>
			</div>
			<div>
				<a href="https://www.interankiety.pl/f/wMpV6mEJ">Satysfakcja Klienta</a>
			</div>
			<div>
				<a href="https://port.szczecin.pl/aktualnosci/od-1-lutego-jestesmy-w-ksef/">KSeF</a>
			</div>
		</StyledFlagWrapper>
	);
};

export default UkrainianCargoFlag;
